<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/expertteam' }"
        >专家咨询</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/expertteam' }"
        >专家团队</el-breadcrumb-item
      >
      <el-breadcrumb-item>专家详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="imgs"><img :src="list.pic" alt="" /></div>
        <div class="details">
          <div class="top">
            <div class="name">{{ list.name }}</div>
            <div class="links">
              <div class="imgs"><img src="./images/wx.png" alt="" /></div>
              <div class="link" @click="open()">立即咨询</div>
            </div>
          </div>
          <div class="btn">
            <div class="years">
              <div class="a">资历：</div>
              <div>
                <span class="b">{{ list.serviceExpres }}</span> 服务经验
              </div>
            </div>
            <div class="consult">
              <div class="headline">领域：</div>
              <div class="headline_box" v-for="(it, ind) in 5" :key="ind">
                生涯规划
              </div>
            </div>
            <div class="intro">
              <div class="a">专家简介：</div>
              <div class="b">
                {{ list.summery }}
              </div>
            </div>
            <div class="territory">
              <div class="a">咨询领域：</div>
              <div class="b">
                {{ list.businessScope }}
              </div>
            </div>
            <div class="experience">
              <div class="a">服务经验：</div>
              <div class="b">
                {{ list.serviceExpres }}
              </div>
            </div>
          </div>
          <el-dialog title="立即咨询" :visible.sync="detailVisible" width="35%">
            <img
              src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.sheji1688.net%2Felement_origin_min_pic%2F20%2F16%2F02%2F1856c57bc150427.jpg%21%2Ffw%2F700%2Fquality%2F90%2Funsharp%2Ftrue%2Fcompress%2Ftrue&refer=http%3A%2F%2Fpic.sheji1688.net&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1669363994&t=7a2ed149154c9f665584736e62b3437a"
              alt=""
            />
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Getdetail } from "@/api/home";
export default {
  name: "XEstudyabroad",

  data() {
    return {
      list: "",
      detailVisible: false,
    };
  },

  async mounted() {
    const res = await Getdetail(this.$route.query.id);
    this.list = res.data||res.result;
  },

  methods: {
    open() {
      this.detailVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";
.box {
  width: 100%;
  background-color: #fff;
  margin-top: 10px;
  min-width: 1050px;
  height: 100%;
  min-height: 890px;
  .content {
    margin-left: 30px;
    display: flex;
    padding: 55px 0 0 80px;
    box-sizing: border-box;
    .imgs {
      width: 117px;
      height: 117px;
      img {
        width: 100%;
      }
    }
    .details {
      margin-left: 3%;
      box-sizing: border-box;
      .top {
        display: flex;
        .name {
          font-size: 36px;
          font-weight: 700;
          color: @blues;
        }
        .links {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          width: 191px;
          height: 60px;
          background: #fff7ee;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          margin-left: 60%;
          .imgs {
            width: 30px;
            height: 30px;
            line-height: 28px;
            text-align: center;
            img {
              width: 100%;
            }
          }
          .link {
            cursor: pointer;
            font-size: 24px;
          }
        }
      }
      .btn {
        width: 90%;
        margin-top: 29px;
        .years {
          display: flex;
          align-items: center;
          margin-bottom: 18px;
          .a {
            font-size: 24px;
            color: #333;
            font-weight: 800;
          }
          div {
            font-size: 20px;
            color: #666666;
            .b {
              color: #7a55ff;
            }
          }
        }
        .consult {
          display: flex;
          margin-bottom: 60px;
          align-items: center;
          .headline {
            font-size: 24px;
            color: #333;
            font-weight: 800;
          }
          .headline_box {
            width: 109px;
            height: 32px;
            border-radius: 38px 38px 38px 38px;
            opacity: 1;
            border: 1px solid #f99f39;
            font-size: 20px;
            color: #666666;
            text-align: center;
            line-height: 32px;
            margin-right: 34px;
          }
        }
        .intro {
          display: flex;
          margin-bottom: 36px;
          box-sizing: border-box;
          .a {
            font-size: 24px;
            color: #333;
            font-weight: 800;
          }
          .b {
            font-size: 20px;
            color: #666666;
            width: 90%;
          }
        }
        .territory {
          display: flex;
          margin-bottom: 36px;
          align-items: center;
          .a {
            font-size: 24px;
            color: #333;
            font-weight: 800;
          }
          .b {
            font-size: 20px;
            color: #666666;
            width: 90%;
          }
        }
        .experience {
          display: flex;
          margin-bottom: 36px;
          align-items: center;
          .a {
            font-size: 24px;
            color: #333;
            font-weight: 800;
          }
          .b {
            font-size: 20px;
            color: #666666;
            width: 90%;
          }
        }
      }
    }
  }
}
</style>